import React from 'react';
import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';

function PriceBoxRelax() {
    const saldoPositivo = useSelector((user) => user.user.nuoviDatiContratto.mono_positivo)
    const saldoNegativo = useSelector((user) => user.user.nuoviDatiContratto.mono_negativo)
    const opzioneTariffaria = useSelector((user) => user.user.info.opzione_tariffaria)
    const quotaFissaPos = useSelector((user) => user.user.nuoviDatiContratto.qf_positivo)
    const quotaFissaNeg = useSelector((user) => user.user.nuoviDatiContratto.qf_negativo)
    const punDaily = useSelector((user) => user.user.info.pun_oggi);

    return (
        <div className="priceBox orange">
            <p className='label'>Prezzo</p>
            <p className='sulLabel'>Applicato in base al consulo mensile</p>
            <div className='neutral'>
                <p className="price">PUN + SPREAD</p>

                <p className='price'>{parseFloat(saldoNegativo - 0.02).toFixed(2).replace(/\./g, ",")}<span> €/kWh </span> {opzioneTariffaria && opzioneTariffaria !== 'D2' ? <span className='quotaFissa'>+{parseFloat(quotaFissaNeg - 0.02).toFixed(2).replace(/\./g, ",")}€ al giorno</span> : null}
                </p>
                {opzioneTariffaria && opzioneTariffaria !== 'D2' && opzioneTariffaria !== 'D3' ? (
                    <p className='iva'>IVA da aggiungere</p>
                ) : null}
            </div>
            <p className="plus">
            * Prezzo calcolato su PUN aggiornato al{" "}
            {DateTime.now().toFormat("dd/MM/y")} di{" "}
            {parseFloat(punDaily).toFixed(4).replace(/\./g, ",")} €/kWh.
            <br /> <br />
            Il Prezzo Unico Nazionale (PUN) è il prezzo della materia prima
            elettrica sul mercato all’ingrosso ed è il valore di riferimento per
            il calcolo del prezzo finale che vedi sulla bolletta della luce. Il
            PUN varia di giorno in giorno e Revoluce lo prende in considerazione
            per ridefinire le tariffe della luce di mese in mese per le offerte
            a prezzo indicizzato.
            <br />
            <br />
            <a
              href="https://www.mercatoelettrico.org/It/Tools/Accessodati.aspx?ReturnUrl=%2fit%2fStatistiche%2fME%2fDatiSintesi.aspx"
              target="_blank"
            >
              Tutti i valori sono pubblicati sul sito del Gestore dei Mercati
              Energeti
            </a>
          </p>
        </div>
    );
}

export default PriceBoxRelax;
